module.exports = __webpack_public_path__ + "static/img/p1-r-1.55825f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-r-1.png
// module id = Mp/8
// module chunks = 0